import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { DEFAULT_RESEARCH_EMAIL_ADDRESS } from '../../../ContactInformation/ContactInformation.constants';
import styles from './SubscribeIndividualArticleMessage.module.scss';
import ContactInformation from '../../../ContactInformation/ContactInformation';

const cx = classNames.bind(styles);

interface SubscribeIndividualArticleMessageProps {
  inlineContent: boolean;
}

const SubscribeIndividualArticleMessage = ({ inlineContent }: SubscribeIndividualArticleMessageProps): ReactElement => {
  return (
    <div className={cx('body')}>
      {inlineContent ? (
        <span className={cx('subtitle')}>
          {
            'Your subscription does not allow access to this report. Avoid missing our indispensable insights by upgrading your account. To learn more, contact your account representative at '
          }
          <ContactInformation emailAddress={DEFAULT_RESEARCH_EMAIL_ADDRESS} />.
        </span>
      ) : (
        <>
          <span className={cx('title')}>
            <b>Your subscription does not allow access to this report</b>
          </span>
          <span className={cx('subtitle')}>
            {
              'Avoid missing our indispensable insights by upgrading your account. To learn more, contact your account representative at '
            }
            <ContactInformation emailAddress={DEFAULT_RESEARCH_EMAIL_ADDRESS} />.
          </span>
        </>
      )}
    </div>
  );
};

export default SubscribeIndividualArticleMessage;
